import React from 'react';
import cx from 'classnames';

export const SummaryHeader = ({ type, children }) => (
  <section className={cx('page-header', `page-header_${type}`)}>{children}</section>
);
